var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "editor/attach_file_24px_rounded") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,6.74762033 L16,17.3276203 C16,19.4176203 14.47,21.2776203 12.39,21.4776203 C10,21.7076203 8,19.8376203 8,17.4976203 L8,5.13762033 C8,3.82762033 8.94,2.63762033 10.24,2.50762033 C11.74,2.35762033 13,3.52762033 13,4.99762033 L13,15.4976203 C13,16.0476203 12.55,16.4976203 12,16.4976203 C11.45,16.4976203 11,16.0476203 11,15.4976203 L11,6.74762033 C11,6.33762033 10.66,5.99762033 10.25,5.99762033 C9.84,5.99762033 9.5,6.33762033 9.5,6.74762033 L9.5,15.3576203 C9.5,16.6676203 10.44,17.8576203 11.74,17.9876203 C13.24,18.1376203 14.5,16.9676203 14.5,15.4976203 L14.5,5.16762033 C14.5,3.07762033 12.97,1.21762033 10.89,1.01762033 C8.51,0.787620327 6.5,2.65762033 6.5,4.99762033 L6.5,17.2676203 C6.5,20.1376203 8.6,22.7076203 11.46,22.9776203 C14.75,23.2776203 17.5,20.7176203 17.5,17.4976203 L17.5,6.74762033 C17.5,6.33762033 17.16,5.99762033 16.75,5.99762033 C16.34,5.99762033 16,6.33762033 16,6.74762033 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editor/attach_file_24px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/editor/attach_file_24px",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Fill",
    mask: "url(#mask-2)",
    fill: "#0F0F0F"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.529a873c7e74c6d0e517f88230f75b50.svg";
export { ForwardRef as ReactComponent };